import React from 'react'
import { Route, Routes } from 'react-router-dom';

import AllQuotation from '../vendors/AllVendors';
import UpdateVendor from '../vendors/UpdateVendor';
import ViewVendor from '../vendors/ViewVendor';
import CreateVendor from '../vendors/CreateVendor';

const QuotationRuotes = () => {
    return (
        <>
            <Routes>
                <Route path="/all" element={<AllQuotation />} />
                <Route path="/create" element={<CreateVendor />} />
                <Route path="/update" element={<UpdateVendor />} />
                <Route path="/view" element={<ViewVendor />} />
            </Routes>
        </>
    )
}

export default QuotationRuotes;